import React from 'react';

import {AutosuggestItem, AutosuggestNoResults} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Loading from '@pb/kit-component-loading';
import Typography from '@pb/kit-component-typography';

import {infoMessage} from './user-suggest-list.module.styl';

import type {UserShortInfo} from '../../openapi/admin/models/UserShortInfo';

type Props = {
    id: string,
    busy: boolean,
    users: UserShortInfo[],
    hasSearched?: boolean,
    isMinQueryShown?: boolean,
};

const MIN_QUERY_MESSAGE = 'The search query is less than the minimum allowed, continue typing...';

export const UserSuggestList: React.FC<Props> = ({id, busy, users, hasSearched = false, isMinQueryShown = false}) => {
    if (busy) {
        return (
            <div id={id} style={{padding: 8, display: 'flex', alignItems: 'center', gap: 8}}>
                <Loading type="ICON"/> <Typography>Loading</Typography>
            </div>
        );
    }

    if (isMinQueryShown) {
        return (
            <Typography style={{padding: 8}}>{MIN_QUERY_MESSAGE}</Typography>
        );
    }

    if (Array.isArray(users) && users.length > 0) {
        return (
            <div id={id}>
                {users.map(user => (
                    <AutosuggestItem
                        key={user.userId}
                        value={user}
                        caption={(
                            <div style={{alignItems: 'center', display: 'flex', gap: 8}}>
                                <div style={{flex: 1, maxWidth: 160}}>
                                    <EllipsisTextHint title={user.email}>
                                        {user.email}
                                    </EllipsisTextHint>
                                </div>
                                <div className={infoMessage} style={{fontSize: 12, maxWidth: 140}}>
                                    <EllipsisTextHint title={`${user.firstName} ${user.lastName}`.trim()}>
                                        {user.firstName} {user.lastName}
                                    </EllipsisTextHint>
                                </div>
                            </div>
                        )}
                    />
                ))}
            </div>
        );
    }

    if (hasSearched) {
        return <AutosuggestNoResults/>;
    }

    return null;
};
